import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { vacancyQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { VacancyFiltersResponse } from "@/types/response/VacancyFiltersResponse";

type UseVacancyFiltersParams = {
  clientId?: string;
  search?: string;
  includeUnpublished?: boolean;
};

export function useVacancyFilters(params: UseVacancyFiltersParams) {
  return useQuery<VacancyFiltersResponse, AxiosError>({
    queryKey: vacancyQueryKeys.filter(
      params.clientId,
      params.search,
      params.includeUnpublished
    ),
    queryFn: () =>
      instance
        .get(`/api/v2/Vacancies/Filters`, {
          params: {
            clientId: params.clientId,
            search: params.search,
            includeUnpublished: params.includeUnpublished,
          },
        })
        .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
